exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.personalSwitch {\n  width: 100%;\n  height: 15.5rem;\n  background: #f7f7f7;\n}\n.personalSwitch .weui-switch:checked,\n.personalSwitch .weui-switch-cp__input:checked ~ .weui-switch-cp__box {\n  border-color: #027cfa;\n  background-color: #027cfa;\n}\n.personalSwitch .weui-label {\n  font-size: 0.3733rem;\n  font-weight: bold;\n}\n.personalSwitch .vux-checker-box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n", ""]);

// exports
